export function deriveErrorMessage(e: any, code: string) {
  const fromErr = (e?.response?.data?.error || e)?.message;
  return `${code}: ${fromErr}`;
}
